module.exports = __webpack_public_path__ + "static/media/LINK-USDC.80e74307.svg";